"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by leon on 6/13/18.
 */
var State = __importStar(require("./store/state"));
var Token = __importStar(require("./store/token"));
var Verifier = __importStar(require("./store/verifier"));
var Storage = /** @class */ (function () {
    function Storage(storageArgs) {
        this.stateStore = new State.StateStorage({
            clientId: storageArgs.clientId,
        });
        this.tokenStore = new Token.TokenStorage({
            clientId: storageArgs.clientId,
        });
        this.verifier = new Verifier.VerifierStorage({
            method: storageArgs.method,
        });
    }
    return Storage;
}());
exports.Storage = Storage;
//# sourceMappingURL=storage.js.map


// WEBPACK FOOTER //
// ./~/@mtfe/sso-web/lib/storage.js